import script from "./file.vue?vue&type=script&setup=true&lang=js"
export * from "./file.vue?vue&type=script&setup=true&lang=js"

import "./file.vue?vue&type=style&index=0&id=06fbe309&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fbe309"]])

export default __exports__